import { Component } from '@angular/core';
import { soundpostReportRunEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Report Runs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportrun-form',
    templateUrl: './soundpostreportrun.form.component.html'
})
export class soundpostReportRunFormComponent extends BaseFormComponent {
    public record!: soundpostReportRunEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reportOutputDeferredRevenueSummaries', sectionName: 'Report Output Deferred Revenue Summaries', isExpanded: false },
            { sectionKey: 'reportOutputDeferredRevenueBySchedules', sectionName: 'Report Output Deferred Revenue By Schedules', isExpanded: false },
            { sectionKey: 'reportOutputDeferredRevenueDetails', sectionName: 'Report Output Deferred Revenue Details', isExpanded: false },
            { sectionKey: 'reportOutputARAgings', sectionName: 'Report Output AR Agings', isExpanded: false }
        ]);
    }
}

